import { etTrailsImg1, etTrailsImg2, etTrailsImg3 } from "../assets/img/imgAssets" 

const trailCategories = [ 'All','Personal', 'Team', 'Leadership']
const trailsData = [
    { 
        id: 1, 
        category: 'Personal', 
        title: 'A better you everyday', 
        image: etTrailsImg1, 
        narrative: 'Keep unlocking and unleashing your personal and professional effectiveness', 
        mode: 'Self Driven', 
        duration: 'Ongoing', 
        stats: { views: 150, likes: 20, comments: 5 } 
    },
    { 
        id: 2, 
        category: 'Personal', 
        title: 'A better you everyday', 
        image: etTrailsImg1, 
        narrative: 'Keep unlocking and unleashing your personal and professional effectiveness', 
        mode: 'Self Driven', 
        duration: 'Ongoing', 
        stats: { views: 150, likes: 20, comments: 5 } 
    },
    { 
        id: 3, 
        category: 'Personal', 
        title: 'A better you everyday', 
        image: etTrailsImg1, 
        narrative: 'Keep unlocking and unleashing your personal and professional effectiveness', 
        mode: 'Self Driven', 
        duration: 'Ongoing', 
        stats: { views: 150, likes: 20, comments: 5 } 
    },
    { 
        id: 4, 
        category: 'Personal', 
        title: 'A better you everyday', 
        image: etTrailsImg1, 
        narrative: 'Keep unlocking and unleashing your personal and professional effectiveness', 
        mode: 'Self Driven', 
        duration: 'Ongoing', 
        stats: { views: 150, likes: 20, comments: 5 } 
    },
    { 
        id: 5, 
        category: 'Team', 
        title: 'A better team everyday', 
        image: etTrailsImg2, 
        narrative: 'Keep unlocking and unleashing your team\'s everyday effectiveness', 
        mode: 'Self Driven', 
        duration: 'Ongoing', 
        stats: { views: 150, likes: 20, comments: 5 } 
    },
    { 
        id: 6, 
        category: 'Team', 
        title: 'A better team everyday', 
        image: etTrailsImg2, 
        narrative: 'Keep unlocking and unleashing your team\'s everyday effectiveness', 
        mode: 'Self Driven', 
        duration: 'Ongoing', 
        stats: { views: 150, likes: 20, comments: 5 } 
    },
    { 
        id: 7, 
        category: 'Team', 
        title: 'A better team everyday', 
        image: etTrailsImg2, 
        narrative: 'Keep unlocking and unleashing your team\'s everyday effectiveness', 
        mode: 'Self Driven', 
        duration: 'Ongoing', 
        stats: { views: 150, likes: 20, comments: 5 } 
    },
    { 
        id: 8, 
        category: 'Team', 
        title: 'A better team everyday', 
        image: etTrailsImg2, 
        narrative: 'Keep unlocking and unleashing your team\'s everyday effectiveness', 
        mode: 'Self Driven', 
        duration: 'Ongoing', 
        stats: { views: 150, likes: 20, comments: 5 } 
    },
    { 
        id: 9, 
        category: 'Leadership', 
        title: 'A better leader everyday', 
        image: etTrailsImg3, 
        narrative: 'Keep unlocking and unleashing your leadership effectiveness', 
        mode: 'Self Driven', 
        duration: 'Ongoing', 
        stats: { views: 150, likes: 20, comments: 5 } 
    },
    { 
        id: 10, 
        category: 'Leadership', 
        title: 'A better leader everyday', 
        image: etTrailsImg3, 
        narrative: 'Keep unlocking and unleashing your leadership effectiveness', 
        mode: 'Self Driven', 
        duration: 'Ongoing', 
        stats: { views: 150, likes: 20, comments: 5 } 
    },
    { 
        id: 11, 
        category: 'Leadership', 
        title: 'A better leader everyday', 
        image: etTrailsImg3, 
        narrative: 'Keep unlocking and unleashing your leadership effectiveness', 
        mode: 'Self Driven', 
        duration: 'Ongoing', 
        stats: { views: 150, likes: 20, comments: 5 } 
    },
    { 
        id: 12, 
        category: 'Leadership', 
        title: 'A better leader everyday', 
        image: etTrailsImg3, 
        narrative: 'Keep unlocking and unleashing your leadership effectiveness', 
        mode: 'Self Driven', 
        duration: 'Ongoing', 
        stats: { views: 150, likes: 20, comments: 5 } 
    },
]
export { trailCategories, trailsData }